import { Button } from "@/components/ui/button-tw";
import { Sweep } from "@/queries/sweeps/types";
import { exportToCsv } from "@/scripts/functions";
import { cn } from "@/utils/classnames";
import { DocumentArrowDownIcon } from "@heroicons/react/24/outline";
import { createColumnHelper } from "@tanstack/react-table";
import dayjs from "dayjs";

const columnHelper = createColumnHelper<Sweep>();

export const columns = [
  columnHelper.accessor(
    (row) => dayjs(row.initiated_on_date).format("MM/DD/YYYY"),
    {
      id: "initiated_on",
      header: "Date",
      sortingFn: (rowA, rowB) => {
        const a = rowA.original.initiated_on_date;
        const b = rowB.original.initiated_on_date;

        if (!a) return -1;
        if (!b) return 1;

        const diff = dayjs(a).diff(b);

        if (diff < 0) return -1;
        if (diff > 0) return 1;
        return 0;
      },
    }
  ),
  columnHelper.accessor("is_completed", {
    id: "status",
    header: "Status",
    enableSorting: false,
    cell: (props) => (
      <span
        className={cn(
          "inline-flex items-center rounded-md bg-blue-50 ml-2 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-600/20",
          {
            "text-green-700 ring-green-600/20 bg-green-50": props.getValue(),
            "text-blue-700 ring-blue-600/20 bg-blue-50": !props.getValue(),
          }
        )}
      >
        <span className="">{props.getValue() ? "Completed" : "Initiated"}</span>
      </span>
    ),
  }),
  columnHelper.accessor(
    (row) => {
      const formatted = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(row.invoice_total);
      return formatted;
    },
    {
      id: "invoice_total",
      header: "Invoice Total",
    }
  ),
  columnHelper.accessor(
    (row) => {
      const formatted = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(row.fee_total || 0);
      return `(${formatted})`;
    },
    {
      id: "fee_total",
      header: "Fee Total",
    }
  ),
  columnHelper.accessor(
    (row) => {
      const formatted = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(row.sweep_total);
      return formatted;
    },
    {
      id: "sweep_total",
      header: "Sweep Total",
    }
  ),
  {
    id: "actions",
    header: () => <span className="sr-only">Actions</span>,
    cell: ({ row }) => {
      const exportContent = row.original.report.map((report) => {
        const res = {};
        for (const [key, value] of Object.entries(report)) {
          res[key] = value;
        }
        return res;
      });

      return (
        <div className="flex justify-end">
          <Button
            size="icon"
            variant="secondary"
            onClick={() => exportToCsv(exportContent, [], "Sweep-Report")}
            className=""
          >
            <DocumentArrowDownIcon className="w-5 h-5" />
          </Button>
        </div>
      );
    },
    enableHiding: false,
  },
];

export default columns;
